/**
 * GoNOW API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2020-12-7
 * Contact: info@zero-spec.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
* The UpdateCustomerTankRequest model module.
* @module model/UpdateCustomerTankRequest
* @version 2020-12-7
*/
export default class UpdateCustomerTankRequest {
    /**
    * Constructs a new <code>UpdateCustomerTankRequest</code>.
    * 顧客タンク更新リクエスト
    * @alias module:model/UpdateCustomerTankRequest
    * @class
    */

    constructor() {
        
        
        
    }

    /**
    * Constructs a <code>UpdateCustomerTankRequest</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/UpdateCustomerTankRequest} obj Optional instance to populate.
    * @return {module:model/UpdateCustomerTankRequest} The populated <code>UpdateCustomerTankRequest</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new UpdateCustomerTankRequest();
                        
            
            if (data.hasOwnProperty('serialNo')) {
                obj['serialNo'] = ApiClient.convertToType(data['serialNo'], 'String');
            }
            if (data.hasOwnProperty('tankType')) {
                obj['tankType'] = ApiClient.convertToType(data['tankType'], 'Number');
            }
            if (data.hasOwnProperty('remarks')) {
                obj['remarks'] = ApiClient.convertToType(data['remarks'], 'String');
            }
            if (data.hasOwnProperty('volumeThreshold')) {
                obj['volumeThreshold'] = ApiClient.convertToType(data['volumeThreshold'], 'Number');
            }
            if (data.hasOwnProperty('deliveryFrequency')) {
                obj['deliveryFrequency'] = ApiClient.convertToType(data['deliveryFrequency'], 'Number');
            }
        }
        return obj;
    }

    /**
    * シリアルナンバー
    * @member {String} serialNo
    */
    'serialNo' = undefined;
    /**
    * タンクタイプID
    * @member {Number} tankType
    */
    'tankType' = undefined;
    /**
    * タンク備考
    * @member {String} remarks
    */
    'remarks' = undefined;
    /**
    * しきい値
    * @member {Number} volumeThreshold
    */
    'volumeThreshold' = undefined;
    /**
    * 配送頻度
    * @member {Number} deliveryFrequency
    */
    'deliveryFrequency' = undefined;




}
